<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">{{ add_day }}日佣金明细</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record sign-record1" ref="content">
      <div class="list">
        <div class="item" v-for="(val, index) in info" :key="index">

          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.bonus_name }}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num" >{{ val.money }}</div>
              <div style="clear:both;"></div>
              <div style="width:100%;font-size:0.25rem;" >{{ val.introduce_show }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .sign-record .list .item .listn .itemn .num {
    width: 3rem;
    text-align: right;
  }
</style>
<script>
import { getBonusList } from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "CommissionDetails";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      commission: 0,
      where: {
        page: 1,
        limit: 20,
          add_day:this.$route.params.add_day,
      },
        add_day:this.$route.params.add_day,
      types: 3,
      loaded: false,
      loading: false
    };
  },
    watch: {
        $route(n) {
            if (n.name === NAME) {
                this.commission = 0;
                this.info = [];
                this.where.add_day = this.$route.params.add_day;
                this.add_day = this.$route.params.add_day;
                this.loaded= false;
                this.loading= false;
                this.where.page = 1;
                this.getIndex();
            }
        }
    },
  mounted: function() {

    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getBonusList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
        that.commission = res.data.allmoney;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },

  }
};
</script>
